export default {
	toggleModal({ commit }, payload) {
		commit('setModalState', payload)
	},
	showCommonBox({ dispatch }) {
		dispatch('toggleModal', {
			name: 'commonBox',
			message: '訊息',
			status: true
		})
	}
}
